import './dashboard_results_view.js.coffee'

Profiling.Dashboard ||= {}

class Profiling.Dashboard.QueryView extends Profiling.Dashboard.ResultsView
  template: JST["backbone/templates/profiling/dashboard_query"]
  defaultSearchMethod: 'filter'

  events: =>
    return _.extend({}, Profiling.Dashboard.ResultsView.prototype.events, {
      'change .order-by': 'orderByUpdate'
      'click .order-direction': 'orderDirectionUpdate'
      'click #next_social_contents_btn': 'next'
    })

  render: ->
    super()
    $('.profiling-dashboard').addClass('explore').removeClass('review')

  next: (event) =>
    @$el.find('#previous_results_link').addClass('processing')
    @searchWith('search', false)

  fetchNewResults: ->
    @$el.find('#new_content_available').addClass('processing')
    @searchWith('realtime', false, @handleRealtimeResults)

  handleQueryResults: (dashboardResults, new_search) =>
    if ( (@page*10) >= @profiles_id.length )
      @$el.find('#previous_results_link').remove()
    else
      @$el.find('#previous_results_link').removeClass('processing')
    super(dashboardResults, new_search)

  handleRealtimeResults: (dashboardResults) =>
    @realtimeContentCheckerView.hide()
    @$el.find('#new_content_available').removeClass('processing')
    _.each(dashboardResults.values, (content) => @addOneToTheBegining(content, Keepcon.tags))
    @updateResultCount(dashboardResults.values.length)
    @trigger('searchCompleted', {})

  addOneToTheBegining: (socialContent, allTags) =>
    @addOne(socialContent, allTags, (element) =>
      @$resultsContainer.prepend(element))

  addOne: (socialContent, allTags, addFunction) =>
    unless allTags
      allTags = []
      console.log("Warning: allTags was undefined for content " + socialContent + ", replaced with []")
    model = new Profiling.Models.ProfilePreview(socialContent)
    view = new Profiling.Dashboard.ResultRow { model, allTags, @currentUser, @accountSettings, @customerData}
    @addAndApplyEffect(view, addFunction) if view
